import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { makeSelectAuth, makeSelectAuthModal } from 'containers/Auth/selectors';
import { makeSelectClientDetails } from 'containers/Main/selectors';
import { moveAnonymousAssessments } from 'containers/Assessment/actions';
import { makeSelectTakenInSession } from 'containers/Assessment/selectors';
import _get from 'lodash/get';
import _isEmpty from 'lodash/isEmpty';

const useAssessmentReminder = () => {
  const dispatch = useDispatch();
  const clientDetails = useSelector(makeSelectClientDetails());
  const auth = useSelector(makeSelectAuth());
  const authModal = useSelector(makeSelectAuthModal());
  const takenInSession = useSelector(makeSelectTakenInSession());
  const mouseHandler = () => dispatch(moveAnonymousAssessments());
  const preventSignIn = _get(clientDetails, 'signIn') === 'Prevent';

  useEffect(() => {
    if (!_isEmpty(takenInSession) && auth.isEmpty && !preventSignIn) {
      document.onmouseleave = mouseHandler;
    } else {
      document.onmouseleave = null;
    }
  }, [auth, takenInSession]);

  useEffect(() => {
    if (authModal.show) {
      document.onmouseleave = null;
    }
  }, [authModal]);
};

export default useAssessmentReminder;
